import { convertFormValuesToDateTimes } from './HourlyServiceDialog/formValues';
import { getSuggestedPromotions } from './HourlySuggestions/getSuggestedPromotions';
import { getTimeRange } from './timeRange';

export const hourlyServiceDialogUtils = { convertFormValuesToDateTimes, getSuggestedPromotions, getTimeRange };
